/* @flow */
import React from 'react'

import './style.css'

const icons = {
  google: 'https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg',
  facebook: 'https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg',
  mail: 'https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg',
}

const SocialButton = ({ type, onClick, ...props }) => {
  const classes = 'social' + (type ? (' social-' + type) : '')
  const text = 'Login with ' + (type ? type : 'email')
  return (
    <button className={classes} onClick={onClick} {...props}>
      <img className="icon" src={icons[type || 'mail']} alt="social media" />
      <div className="text">{ text }</div>
    </button>
  )
}

export default SocialButton


// WEBPACK FOOTER //
// ./src/components/SocialButton/index.js